import { render, staticRenderFns } from "./super_sidebar_toggle.vue?vue&type=template&id=3c6d417d&vue3"
import script from "./super_sidebar_toggle.vue?vue&type=script&lang=js&vue3"
export * from "./super_sidebar_toggle.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports